import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sunIcon", "moonIcon"]

  connect() {
    const saved = localStorage.getItem("sw-theme") || document.cookie.match(/sw_theme=([^;]+)/)?.[1]
    if (saved === "dark") {
      document.documentElement.classList.add("sw-dark")
    }
    this.updateIcons()
  }

  toggle() {
    const dark = document.documentElement.classList.toggle("sw-dark")
    const value = dark ? "dark" : "light"
    localStorage.setItem("sw-theme", value)
    document.cookie = `sw_theme=${value}; path=/; max-age=31536000; SameSite=Lax`
    this.updateIcons()
  }

  updateIcons() {
    const dark = document.documentElement.classList.contains("sw-dark")
    this.sunIconTargets.forEach(el => el.style.display  = dark ? "flex" : "none")
    this.moonIconTargets.forEach(el => el.style.display = dark ? "none" : "flex")
  }
}
